exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb-message-badge .el-badge__content.is-fixed.is-dot{\r\n  top: 20px;\n}\r\n", ""]);

// exports
